module.exports = __webpack_public_path__ + "static/img/DonovanFrew.1b32dd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/board/DonovanFrew.jpg
// module id = bhm5
// module chunks = 0